function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Calendar filter (NLRSUPPORT-402).
 * Progressive enhancement over the server-rendered calendar list:
 * multiselect dropdowns + search fetch the list via AJAX (?ajax=1) and
 * swap the #calendar-results region, keeping the URL in sync with pushState.
 */
var ROOT = '[data-component="calendarFilter"]';
var RESULTS = '[data-calendar-results]';
var DEBOUNCE_MS = 400;
var CalendarFilter = /*#__PURE__*/function () {
  function CalendarFilter(root) {
    _classCallCheck(this, CalendarFilter);
    this.root = root;
    this.results = document.querySelector(RESULTS);
    this.searchInput = root.querySelector('[data-element="calendarSearch"]');
    this.dropdowns = Array.from(root.querySelectorAll('[data-element="filterDropdown"]'));
    this.clearBtn = root.querySelector('[data-element="filterClear"]');
    this.debounceTimer = null;
    this.bind();
    this.syncHierarchy();
    this.updateCounts();
  }
  return _createClass(CalendarFilter, [{
    key: "bind",
    value: function bind() {
      var _this = this;
      this.dropdowns.forEach(function (dd) {
        var toggle = dd.querySelector('[data-element="filterToggle"]');
        var menu = dd.querySelector('[data-element="filterMenu"]');
        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = !menu.hidden;
          _this.closeAll();
          if (!isOpen) {
            menu.hidden = false;
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
        menu.addEventListener('click', function (e) {
          return e.stopPropagation();
        });
        menu.addEventListener('change', function (e) {
          _this.updateHierarchy(e.target);
          _this.updateCounts();
          _this.apply(false);
        });
        var menuClear = dd.querySelector('[data-element="menuClear"]');
        if (menuClear) {
          menuClear.addEventListener('click', function () {
            return _this.clearDropdown(dd);
          });
        }
      });
      if (this.searchInput) {
        this.searchInput.addEventListener('input', function () {
          return _this.apply(true);
        });
      }
      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', function () {
          return _this.clear();
        });
      }
      document.addEventListener('click', function () {
        return _this.closeAll();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') _this.closeAll();
      });

      // Featured event-type cards (in the hero) act as preset filters: filter by
      // that type over AJAX instead of navigating. Falls back to the link's href
      // when there is no results region to swap.
      document.addEventListener('click', function (e) {
        var card = e.target.closest('[data-type-filter]');
        if (!card || !_this.results) return;
        e.preventDefault();
        _this.applyTypePreset(card.dataset.typeFilter);
      });
      if (this.results) {
        this.results.addEventListener('click', function (e) {
          return _this.onResultsClick(e);
        });
      }
      window.addEventListener('popstate', function () {
        _this.syncControls(window.location.search);
        _this.load(window.location.search, true);
      });
    }
  }, {
    key: "closeAll",
    value: function closeAll() {
      this.dropdowns.forEach(function (dd) {
        var menu = dd.querySelector('[data-element="filterMenu"]');
        var toggle = dd.querySelector('[data-element="filterToggle"]');
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  }, {
    key: "groupInputs",
    value: function groupInputs(dd, group) {
      return Array.from(dd.querySelectorAll('input[type="checkbox"]')).filter(function (input) {
        return input.dataset.filterGroup === group;
      });
    }
  }, {
    key: "updateHierarchy",
    value: function updateHierarchy(input) {
      if (!input.matches('input[type="checkbox"][data-filter-group]')) return;
      var dd = input.closest('[data-element="filterDropdown"]');
      var groupInputs = this.groupInputs(dd, input.dataset.filterGroup);
      var parent = groupInputs.find(function (option) {
        return option.dataset.role === 'filterParent';
      });
      var children = groupInputs.filter(function (option) {
        return option.dataset.role === 'filterChild';
      });
      if (!parent || !children.length) return;
      if (input === parent) {
        parent.indeterminate = false;
        children.forEach(function (child) {
          child.checked = parent.checked;
        });
        return;
      }
      var checkedChildren = children.filter(function (child) {
        return child.checked;
      }).length;
      parent.checked = checkedChildren === children.length;
      parent.indeterminate = checkedChildren > 0 && checkedChildren < children.length;
    }
  }, {
    key: "syncHierarchy",
    value: function syncHierarchy() {
      var _this2 = this;
      this.dropdowns.forEach(function (dd) {
        dd.querySelectorAll('[data-role="filterParent"]').forEach(function (parent) {
          var groupInputs = _this2.groupInputs(dd, parent.dataset.filterGroup);
          var children = groupInputs.filter(function (option) {
            return option.dataset.role === 'filterChild';
          });
          if (!children.length) return;
          if (parent.checked) {
            children.forEach(function (child) {
              child.checked = true;
            });
          } else {
            _this2.updateHierarchy(children[0]);
          }
        });
      });
    }
  }, {
    key: "updateCounts",
    value: function updateCounts() {
      var total = 0;
      this.dropdowns.forEach(function (dd) {
        var count = dd.querySelectorAll('input[type="checkbox"]:checked').length;
        total += count;
        var badge = dd.querySelector('[data-element="filterCount"]');
        if (count > 0) {
          badge.hidden = false;
          badge.textContent = count;
        } else {
          badge.hidden = true;
        }
        var menuClear = dd.querySelector('[data-element="menuClear"]');
        if (menuClear) menuClear.hidden = count === 0;
      });
      if (this.clearBtn) {
        this.clearBtn.disabled = total === 0 && !(this.searchInput && this.searchInput.value.trim());
      }
    }
  }, {
    key: "clearDropdown",
    value: function clearDropdown(dd) {
      dd.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
        c.checked = false;
        c.indeterminate = false;
      });
      this.updateCounts();
      this.apply(false);
    }
  }, {
    key: "applyTypePreset",
    value: function applyTypePreset(slugs) {
      // Behaves like the card's href: resets other filters and selects the
      // featured type together with any child types, then loads via AJAX.
      var search = "?type=".concat(encodeURIComponent(slugs));
      window.history.pushState({}, '', window.location.pathname + search);
      this.syncControls(search);
      this.load(search, true);
      // this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, {
    key: "buildParams",
    value: function buildParams() {
      var params = new URLSearchParams();
      this.dropdowns.forEach(function (dd) {
        var param = dd.dataset.param;
        var values = Array.from(dd.querySelectorAll('input[type="checkbox"]:checked')).map(function (c) {
          return c.value;
        });
        if (values.length) params.set(param, values.join(','));
      });
      var text = this.searchInput && this.searchInput.value.trim();
      if (text) params.set('text', text);
      return params;
    }
  }, {
    key: "apply",
    value: function apply(debounced) {
      var _this3 = this;
      var run = function run() {
        var qs = _this3.buildParams().toString();
        var search = qs ? "?".concat(qs) : '';
        window.history.pushState({}, '', window.location.pathname + search);
        _this3.load(search, true);
        _this3.updateCounts();
      };
      if (debounced) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(run, DEBOUNCE_MS);
      } else {
        run();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.root.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
        c.checked = false;
        c.indeterminate = false;
      });
      if (this.searchInput) this.searchInput.value = '';
      this.updateCounts();
      this.apply(false);
    }
  }, {
    key: "syncControls",
    value: function syncControls(search) {
      var params = new URLSearchParams(search.replace(/^\?/, ''));
      this.dropdowns.forEach(function (dd) {
        var values = (params.get(dd.dataset.param) || '').split(',').filter(Boolean);
        dd.querySelectorAll('input[type="checkbox"]').forEach(function (c) {
          c.checked = values.indexOf(c.value) !== -1;
          c.indeterminate = false;
        });
      });
      if (this.searchInput) this.searchInput.value = params.get('text') || '';
      this.syncHierarchy();
      this.updateCounts();
    }
  }, {
    key: "onResultsClick",
    value: function onResultsClick(e) {
      var link = e.target.closest('a');
      if (!link || !this.results.contains(link)) return;
      if (!link.closest('.p-pagination')) return;
      e.preventDefault();
      var url = new URL(link.href, window.location.origin);
      var params = new URLSearchParams(url.search);
      params["delete"]('ajax');
      var clean = params.toString();
      var search = clean ? "?".concat(clean) : '';
      window.history.pushState({}, '', url.pathname + search);
      this.load(search, true);
      // Scroll to the search/filter bar so search + all filters stay in view.
      this.root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, {
    key: "load",
    value: function load(search, showSpinner) {
      var _this4 = this;
      if (!this.results) return;
      var params = new URLSearchParams(search.replace(/^\?/, ''));
      params.set('ajax', '1');
      var fetchUrl = "".concat(window.location.pathname, "?").concat(params.toString());
      if (showSpinner) this.results.classList.add('is-fetching');
      fetch(fetchUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (r) {
        return r.text();
      }).then(function (html) {
        _this4.results.innerHTML = html;
        _this4.results.classList.remove('is-fetching');
      })["catch"](function () {
        _this4.results.classList.remove('is-fetching');
      });
    }
  }]);
}();
Array.from(document.querySelectorAll(ROOT)).forEach(function (root) {
  return new CalendarFilter(root);
});